import { env } from '@/config/env';

import { OFFLINE_ENDPOINTS } from './endpoints.offline';
import { ONLINE_ENDPOINTS } from './endpoints.online';

export const API_ENDPOINTS = env.IS_OFFLINE
  ? OFFLINE_ENDPOINTS
  : ONLINE_ENDPOINTS;

export { OFFLINE_ENDPOINTS } from './endpoints.offline';
export { ONLINE_ENDPOINTS } from './endpoints.online';
